import { render, staticRenderFns } from "./DialogPageCategory.vue?vue&type=template&id=0432c7ec&scoped=true&"
import script from "./DialogPageCategory.vue?vue&type=script&lang=js&"
export * from "./DialogPageCategory.vue?vue&type=script&lang=js&"
import style0 from "./DialogPageCategory.vue?vue&type=style&index=0&id=0432c7ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0432c7ec",
  null
  
)

export default component.exports